import React from 'react';

export function CheckIcon() {
  // https://lucide.dev/icons/check
  return (
    <g stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 6 9 17l-5-5" />
    </g>
  );
}
